import { useTranslation } from 'react-i18next'

import { ScrollableTabs } from '@reveni-io/reveni-ui'

import useTabsSearchParam from '../hooks/useTabsSearchParam/useTabsSearchParam'
import LayoutTab from './LayoutTab/LayoutTab'
import VisibilityCriteriaTab from './VisibilityCriteriaTab/VisibilityCriteriaTab'
import { orderTrackingPageTabList, orderTrackingPageTabs } from './constants'
import * as Styles from './styles'

const OrderTrackingPageConfiguration = () => {
  const { t } = useTranslation()

  const tabs = orderTrackingPageTabList.map(tab => ({ ...tab, label: t(tab.label) }))

  const { activeTab, onChangeTab } = useTabsSearchParam({ tabs, defaultTab: orderTrackingPageTabs.layout })

  return (
    <Styles.Container>
      <ScrollableTabs tabs={tabs} value={activeTab} onChange={onChangeTab} />
      {activeTab === orderTrackingPageTabs.layout && <LayoutTab />}
      {activeTab === orderTrackingPageTabs.visibilityCriteria && <VisibilityCriteriaTab />}
    </Styles.Container>
  )
}

export default OrderTrackingPageConfiguration
